import { useInfiniteQuery } from '@tanstack/react-query';
import { endpoints, Url, withSideload } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';
import { asScalar, parse } from '../../../../lib/url';
import { DISALLOWED_STATUSES_FILTER_ITEM } from '../../../document-list-columns/status/statuses';
import { ValidatedGridFilterItem } from '../../../document-list-filtering/types';
import { detailsEncoder } from '../../../mql/detailsCodec';
import { encodeMqlQuery } from '../../../mql/encodeMqlQuery';
import { ACCESSIBLE_ANNOTATIONS_FILTER_ITEM } from '../../../pricing/utils';
import { FORMULA_PREVIEW_KEY } from '../../keys';

export const DEFAULT_PAGE_SIZE = 5;

const query = {
  ordering: '-created_at',
};

export const useGetAnnotationsForPreview = ({
  queueUrls,
  pageSize,
  disabled,
  filters,
}: {
  queueUrls: Url[];
  pageSize: number;
  disabled?: boolean;
  filters: ValidatedGridFilterItem[];
}) => {
  const mqlQueryPayload = encodeMqlQuery(
    [
      ...filters,
      ACCESSIBLE_ANNOTATIONS_FILTER_ITEM,
      DISALLOWED_STATUSES_FILTER_ITEM,
    ],
    {
      columnEncoders: {
        details: detailsEncoder,
      },
    }
  );

  const annotationsQuery = useInfiniteQuery({
    queryKey: [
      FORMULA_PREVIEW_KEY,
      'annotations',
      mqlQueryPayload,
      pageSize,
    ] as const,
    queryFn: ({ pageParam: searchAfter }) =>
      api.request(
        withSideload(
          endpoints.annotations.search(
            { ...query, pageSize, searchAfter },
            { query: mqlQueryPayload }
          ),
          { documents: true }
        )
      ),
    getNextPageParam: data => {
      if (data.pagination.next) {
        return asScalar(parse(data.pagination.next)['search_after']);
      }

      return undefined;
    },
    cacheTime: 0, // clears data on closing drawer
    enabled: queueUrls.length > 0 && !disabled,
  });

  return annotationsQuery;
};
